import { styled } from '~/lite'

import { View } from '../View/View'

export const Page = styled(View)`
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
`
